import { useContext } from 'react'
import { useLocation } from 'react-router-dom'
import AppProviders from 'providers'
import Routes from 'routes'
import PopUpHealth from 'views/agegate/components/popUpHealth'
import { LoaderContext } from 'contexts/loader-context'
import { useAgegateConfig } from 'hooks/use-agegate'
import LoadingScreen from 'components/loading-screen'
import Footer from 'components/footer'
import Header from 'components/header'
import FacebookSDK from 'components/facebookSDK'
import CONFIGS from 'build/Config'
import ComingSoon from './components/coming-soon'

function App() {
  const { load } = useContext(LoaderContext)
  const location = useLocation()
  useAgegateConfig()

  const isEventsInfoPage = location.pathname.startsWith('/events-info')
  const isCampaignsInfoPage = location.pathname.startsWith('/campaigns')
  // Full-bleed pages (no app-container max-width): redesign home, neighbars
  // and the age gate (its glass card sizes itself per breakpoint)
  const validPaths = ['/', '/home', '/start', '/neighbars', '/afterwork', '/pitstops', '/credenciales', '/agegate']

  const shouldApplyExtraClasses = CONFIGS?.versionPh && !(validPaths.includes(location.pathname) || isEventsInfoPage || isCampaignsInfoPage)

  const classNames = `w-full flex-1 flex flex-col ${shouldApplyExtraClasses ? 'sm:max-w-md z-1 app-container' : ''}`

  return (
    <AppProviders>
      <ComingSoon>
        {FC_CLIENTID && <FacebookSDK />}
        {load && <LoadingScreen />}
        <Header />
        <div className={classNames}>
          <PopUpHealth />
          <Routes />
        </div>
        <Footer />
      </ComingSoon>
    </AppProviders>
  )
}

export default App
